import React, { Component } from 'react'
import { Row, Col, Container, Collapse, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import EirButton from '../../eir-button/EirButton';
import { csrSubscriber, oneOffPayment } from './../apis/accountManagementApis';
import { RealexHpp } from '../rxp-js';
import EirErrorModal from '../EirErrorModal';
import Loading from './../../shared/Loading';
import { EIR_WEBMAIL_CONST } from '../constants/EirWebmailConstants';
import axios from 'axios';

class AccountDetails extends Component {
    constructor(props) { 
        super(props)

        this.state = {
            isOpen: false,
            modal: false,
            errorModal: false,
            createResponse: '',
            iFrameLoading: false,
            paymentCenterDown: false,
            declinedModel: false
        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })

        if (!this.state.isOpen) {
            this.setState({
                iFrameLoading: true
            })

            oneOffPayment.post('/webmail/prospect/oop/create', {
                "email": this.props.subscriber.email,
                "plan": 'plan599',
            }).then((response) => {
                axios({
                    method: 'get',
                    url: EIR_WEBMAIL_CONST.url.PAYMENT_CENTER_STATUS,
                }).then(res => {
                    if (res.data.status === "UP") {
                        this.setState({
                            createResponse: response.data,
                            iFrameLoading: false
                        })
                        RealexHpp.embedded.init(
                            "oneOffPayment",
                            "oneOffPayment-iframe",
                            "localhost",
                            response.data,
                            this.oneOffPayCallback,
                        );
                    }
                    else {
                        this.setState({
                            iFrameLoading: false,
                            paymentCenterDown: true,
                            isOpen: !this.state.isOpen
                        });
                    }
                }).catch(err => {
                    this.setState({
                        iFrameLoading: false,
                        paymentCenterDown: true,
                        isOpen: !this.state.isOpen
                    });
                })

            })
                .catch((error) => {
                    console.log('error', error)
                    if (error.response.status === 403) {
                        return window.location.href = '/email/login'
                    }
                    this.setState({
                        errorModal: true,
                        iFrameLoading: false,
                        isOpen: !this.state.isOpen
                    })
                })

        }
    }

    oneOffPayCallback = hpp => {
        oneOffPayment.post(`/webmail/prospect/oop/${this.props.subscriber.uuid}/callback`, {
            "encoded": true,
            "hppResponse": hpp
        })
            .then((response) => {
                this.props.subscriberCall(true)
                this.props.oneOffPaymentMessage(true)
                this.setState({
                    isOpen: !this.state.isOpen,
                })
            })
            .catch((error) => {
                console.log('error', error)
                if (error.response.status === 403) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    isOpen: !this.state.isOpen,
                    declinedModel: !this.state.declinedModel,
                })
            });
    }

    toggleError = (param) => {
        this.setState({
            errorModal: param
        })
    }

    toggleCancelSubscription = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    declinedModel = () => {
        this.setState({
            declinedModel: !this.state.declinedModel
        })
    }

    cancelSubscription = () => {
        this.setState({
            modal: !this.state.modal
        });

        csrSubscriber.post(`subscriber/${this.props.subscriber.email}/cease`) //as only a csr can cancel subscription for a user
            .then((response) => {
                window.location.reload(false);
            }).catch((error) => {
                console.log('error ', error);
                if (error.response.status === 403) {
                    return window.location.href = '/email/login'
                }
                this.setState({
                    errorModal: true
                })
            });
    }

    render() {
        return (
            <Container className='account-details-main'>
                <Row>
                    <Col xs='12' sm='12' md='6' lg='6'>
                        <Row>
                            <p><b>Balance: </b> <span className='account-arrears'>€{this.props.bill.currentBalance && this.props.bill.currentBalance / 100}</span></p>
                        </Row>
                        <Row>
                            <p><b>Payment Status: </b> <span className='account-arrears'>{this.props.subscriber.status}</span></p>
                        </Row>
                    </Col>
                    {
                        !this.state.isOpen &&
                        <Col xs='12' sm='12' md='6' lg='6' className='paynow-button'>
                            <EirButton type='button' text='pay now' id='oneOffPayment' disabled={(this.props.subscriber.status !== 'ARREARS' && this.props.subscriber.status !== 'PENDING_CEASE')} className='webmail-btn pay-now' onClick={this.toggle} /> {/*To be changed back to what it was */}
                            {
                                // (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN') === '0_') &&
                                <EirButton type='button' text='Cancel Subscription' disabled={this.props.subscriber.status === 'PENDING_CEASE'} className='webmail-btn pay-now' onClick={this.toggleCancelSubscription} />
                            }
                        </Col>
                    }
                </Row>
                <Row>
                    <Col>
                        {
                            !this.state.iFrameLoading &&
                            <Collapse isOpen={this.state.isOpen}>
                                <div>
                                    The credit card used in this once off payment transaction will be stored on your account <b>in addition to any</b> credit card(s) already stored. If you want to delete this credit card after the transaction then you will be able to do so from the account management page.
                                </div>

                                <iframe
                                    id="oneOffPayment-iframe"
                                    frameBorder="0"

                                    style={{
                                        display: 'inline-block',
                                        width: '100%',
                                        align: 'centre',
                                        minHeight: '600px',
                                        position: 'relative',
                                        margin: '1rem 0'
                                    }}
                                />
                            </Collapse>
                        }
                        {
                            this.state.iFrameLoading &&
                            <div className="add-card-loader text-center mt-5 text-secondary mt-4" >
                                <Loading />
                            </div>
                        }
                    </Col>

                </Row>
                {
                    this.state.isOpen && !this.state.iFrameLoading &&
                    <Row className='account-payment-butttons'>
                        <EirButton type='button' text='cancel' className='webmail-btn' onClick={this.toggle} />
                    </Row>
                }

                <Modal isOpen={this.state.modal} centered={true} toggle={this.toggleCancelSubscription}>
                    <ModalHeader toggle={this.toggleCancelSubscription}>Cancel Subscription</ModalHeader>
                    <ModalBody>
                        <p>Are you sure you want to cancel the subscription for this customer?</p>
                        <p><b>Email: </b>{this.props.subscriber.email}</p>
                    </ModalBody>
                    <ModalFooter>
                        <EirButton className='webmail-btn' type='button' text='YES' onClick={this.cancelSubscription}></EirButton>{' '}
                        <EirButton className='webmail-btn btn-outline-primary eir-text-secondary' color='white' type='button' text='NO' onClick={this.toggleCancelSubscription}></EirButton>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.declinedModel} centered={true} toggle={this.declinedModel}>
                    <ModalHeader toggle={this.declinedModel}>Alert</ModalHeader>
                    <ModalBody className='text-center'>
                        Your payment was declined. <br />
                        Please try again
                    </ModalBody>
                    <ModalFooter>
                        <EirButton className='webmail-btn' type='button' text='Ok' onClick={this.declinedModel}></EirButton>{' '}
                    </ModalFooter>
                </Modal>

                {this.state.paymentCenterDown &&
                    <div className="d-flex justify-content-center align-items-center">
                        <p className="mt-3 text-danger text-center">We are currently unable to process this payment - Please try again later</p>
                    </div>
                }

                {
                    this.state.errorModal &&
                    <EirErrorModal toggleError={this.toggleError} errorModal={this.state.errorModal} />
                }
            </Container>
        )
    }
}

export default AccountDetails